// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__container";
var _2 = "webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__heading";
var _3 = "webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__icon";
var _4 = "webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__merged webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__container";
var _5 = "webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__reference";
var _6 = "webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__referenceLink";
var _7 = "webpack-concepts-Extraction-StudyList-ReferenceDocuments-module__referenceUrl";
export { _1 as "container", _2 as "heading", _3 as "icon", _4 as "merged", _5 as "reference", _6 as "referenceLink", _7 as "referenceUrl" }
